import { render, staticRenderFns } from "./AccountChangePassword.vue?vue&type=template&id=c1354e1e&scoped=true"
import script from "./AccountChangePassword.vue?vue&type=script&lang=js"
export * from "./AccountChangePassword.vue?vue&type=script&lang=js"
import style0 from "./AccountChangePassword.vue?vue&type=style&index=0&id=c1354e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1354e1e",
  null
  
)

export default component.exports